// libs
import React, { memo } from 'react';

// helpers
import { inPriceFormat } from 'shared/helpers/utils';

// styles
import { Container, Discount, OriginalPrice, Currency, AmountWrapper } from './styles';

// constants
import { DEFAULT_CURRENCY } from 'shared/constants';

const DISCOUNT_TEXT = '%';

export interface IPriceWithDiscountProps {
  discount?: string | number;
  discountedPrice?: number;
  price: string | number;
  className?: string;
}

function Price({
  discount = 0,
  discountedPrice = 0,
  price,
  className = '',
}: IPriceWithDiscountProps) {
  if (price === undefined) {
    return null;
  }
  const formattedPrice = inPriceFormat(price);
  const formattedDiscountedPrice = inPriceFormat(discountedPrice);

  return (
    <Container
      className={className}
      data-test={discount > 0 ? 'discount-price-container' : 'no-discount-price-container'}
    >
      {discount > 0 ? (
        <>
          <AmountWrapper data-test="discounted-price">
            <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
            {formattedDiscountedPrice}
          </AmountWrapper>
          <OriginalPrice data-test="original-price">
            <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
            {formattedPrice}
          </OriginalPrice>
          <Discount data-test="discount-percent">
            {discount}
            {DISCOUNT_TEXT}
          </Discount>
        </>
      ) : (
        <AmountWrapper data-test="amount">
          <Currency data-test="currency">{DEFAULT_CURRENCY}</Currency>
          {formattedPrice}
        </AmountWrapper>
      )}
    </Container>
  );
}

export default memo(Price);
